import { __decorate } from "tslib";
import { mapActions, mapGetters } from "vuex";
import MoneyField from "@/components/MoneyField.vue";
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import DateInput from "@/components/DateInput.vue";
import DatePicker from "@/components/DatePicker.vue";
import TeamSelect from "@/components/TeamSelect.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import CompanyExpenses from "@/components/CompanyExpenses.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ExpenseType, PaymentMethod } from "@/model-types/expense";
let PayoutModal = class PayoutModal extends Vue {
    id;
    hideForm = false;
    errors = {};
    title = "New expense";
    data = { staffId: '' };
    paymentMethods = [];
    calendarOptions = { maxDate: new Date() };
    ExpenseType = ExpenseType;
    payoutType = ExpenseType.salary;
    fetchUserById;
    getUserById;
    create;
    patch;
    remove;
    created() {
        this.paymentMethods = [
            { text: this.$t("Cash"), value: PaymentMethod.cash },
            { text: this.$t("Card"), value: PaymentMethod.card },
            { text: this.$t("Other"), value: PaymentMethod.other },
        ];
    }
    get selectedUser() {
        return this.getUserById(this.data.staffId);
    }
    staffIdWatcher(newVal) {
        this.fetchUserById(newVal);
    }
    showBalance() {
        if (!this.data.staffId)
            return;
        if (this.selectedUser && !this.selectedUser.balance) {
            this.selectedUser.balance = 0;
        }
        this.data.amount = this.selectedUser.balance;
    }
    shown() {
        this.errors = {};
        this.data.paymentMethod = this.paymentMethods[0].value;
        const { User } = this.$FeathersVuex;
        let data = User.getFromStore("temp");
        if (data) {
            new User({ _id: "temp" });
        }
        if (data.model) {
            this.data.staffId = data.model._id;
            this.payoutType = data.model.type || ExpenseType.salary;
        }
    }
    hidden() {
        this.data = {};
    }
    deleteAction() {
        this.remove(this.data._id).then((result) => {
            this.$toasted.global.success({
                message: this.$t("Item has been removed"),
            });
        });
    }
    saveAction() {
        let promise, successMessage;
        let data = Object.assign({ type: this.payoutType }, this.data);
        if (this.payoutType === ExpenseType.office)
            this.data.staffId = '';
        if (this.data._id) {
            promise = this.patch([this.data._id, data, {}]);
            successMessage = "Expense updated";
        }
        else {
            promise = this.create(data);
            successMessage = "Expense added";
        }
        promise.then((data) => {
            this.$root.$emit("bv::hide::modal", this.id);
            this.$toasted.global.success({
                message: this.$t(successMessage),
            });
        });
        promise.catch((err) => {
            this.errors = err.errors;
            this.$toasted.show(err.message, {
                theme: "bubble",
                position: "top-right",
                duration: 3000,
            });
        });
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
};
__decorate([
    Prop(String)
], PayoutModal.prototype, "id", void 0);
__decorate([
    Watch('data.staffId')
], PayoutModal.prototype, "staffIdWatcher", null);
PayoutModal = __decorate([
    Component({
        components: {
            Modal,
            MoneyField,
            Money,
            DateInput,
            DatePicker,
            TeamSelect,
            CustomSwitch,
            CompanyExpenses,
        },
        methods: {
            ...mapActions("expense", ["create", "patch", "remove"]),
            ...mapActions("users", { fetchUserById: "get" }),
        },
        computed: {
            ...mapGetters("users", { getUserById: "get" }),
        }
    })
], PayoutModal);
export default PayoutModal;
;
